import { Field, Form, Formik } from "formik";
import React from "react";
import { Card, Message, Feed, Header } from "semantic-ui-react";
import * as Yup from "yup";
import { Checkbox } from "components/Form/SpecialButtons";
import MainButton from "components/Buttons/MainButton";
import CustomTextareaComponent from "components/Form/CustomTextareaComponent";
import moment from "moment";

const schemaValidation = Yup.object().shape({
	geslab_alert: Yup.boolean().required("Champ requis"),
	geslab_alert_comment: Yup.string().when("geslab_alert", {
		is: true,
		then: Yup.string().required("Champ requis"),
	}),
});

const GeslabAlert = ({ folder, submit, disabled }) => {
	return (
		<Card style={{ width: "100%" }}>
			<Card.Content>
				<Formik
					initialValues={{
						geslab_alert: folder.geslab_alert || false,
						geslab_alert_comment: folder.geslab_alert_comment || "",
					}}
					validationSchema={schemaValidation}
					onSubmit={(values) => {
						submit(values);
					}}
				>
					{({ submitForm, values, handleChange, setFieldValue }) => {
						return (
							<Form>
								<Message
									info
									content="Si vous rencontrez des difficultés avec ce dossier et que vous n'êtes pas sûr des informations, merci de cocher la case ci-dessous et d'en indiquer la raison dans le champ commentaire. "
								/>
								<Field
									id="geslab_alert"
									name="geslab_alert"
									customlabel="Alerte saisie Geslab"
									component={Checkbox}
									required
									onChange={(e) => {
										//If the value is true, it means that the user unchecked the box and we should remove the comment
										if (values.geslab_alert) setFieldValue("geslab_alert_comment", "");
										handleChange(e);
									}}
									disabled={disabled}
								/>
								{values.geslab_alert && (
									<>
										<Field
											type="text"
											name="geslab_alert_comment"
											customlabel="Commentaire"
											component={CustomTextareaComponent}
											required={values.geslab_alert}
											disabled={!values.geslab_alert || disabled}
											rows="4"
										/>
										<MainButton
											type="button"
											style={{ float: "right", margin: "10px 0 0 0" }}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												submitForm();
											}}
											text="Sauvegarder"
											disabled={disabled}
										/>
									</>
								)}
							</Form>
						);
					}}
				</Formik>
				{folder.geslab_alerts && folder.geslab_alerts.length > 0 && (
					<Feed>
						<Header as="h4">Historique des alertes</Header>
						{folder.geslab_alerts.map((ga) => (
							<Feed.Event>
								<Feed.Content>
									<Feed.Date>{moment(ga.created_date).format("DD/MM/YYYY à HH:mm")}</Feed.Date>
									<Feed.Summary>{ga.user} a ajouté un message</Feed.Summary> <Feed.Extra text>{ga.comment}</Feed.Extra>
								</Feed.Content>
							</Feed.Event>
						))}
					</Feed>
				)}
			</Card.Content>
		</Card>
	);
};

export default GeslabAlert;
